<app-main-dialog (dismiss)="dismiss()">
  <div modalTitle>
    {{ 'report.new.note' | translate }}
  </div>
  <form [formGroup]="formGroup">
    <ion-label>{{ 'item.name' | translate }}</ion-label>
    <ion-item lines="none">
      <ion-input autocapitalize="on"
        formControlName="name"></ion-input>
    </ion-item>
    <div class="tw:flex">
      <app-pick-media [name]="'reportNote'"
        [accept]="'image/*,video/*'"
        (filesSelected)="onFilesSelected($event)"
        (imageUrl)="onUrl($event)"
        (videoUrl)="onUrl($event)"
        (imageUrls)="onUrls($event)"></app-pick-media>
    </div>
    <ion-item class="description"
      lines="none">
      <ion-textarea autocapitalize="on"
        formControlName="text"
        rows="5"
        [placeholder]="'kanban.problemTitle' | translate">
      </ion-textarea>
    </ion-item>
    <ion-button expand="block"
      shape="round"
      color="secondary"
      (click)="selectArea()">
      @if (formGroup.get('area').value; as room) {
        {{ room }}
      } @else {
        {{ 'calendar.site.area' | translate }}
      }
    </ion-button>
    <div class="ion-margin-top">
      <ion-button color="light"
        shape="round"
        (click)="onSave()">
        {{ 'general.save' | translate }}
      </ion-button>
    </div>
  </form>
</app-main-dialog>
